var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('body', [_c('div', {
    staticClass: "page-wrapper"
  }, [_c('div', {
    staticClass: "login"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 d-flex align-items-center justify-content-center"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "login_logo",
    attrs: {
      "src": "static/img/XB_main_logo.svg",
      "alt": "homepage"
    }
  }), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("Welcome")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("Xpressbees Customer Relationship Management")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    ref: "logbutton",
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.checklogin
    }
  }, [_vm._v("Login")])]), _vm._v(" "), _vm._m(1)])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-img"
  }, [_c('img', {
    staticClass: "full-width-img",
    attrs: {
      "src": "static/img/login_bg.svg",
      "alt": "background"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "color": "red",
      "font-size": "12px"
    }
  }, [_c('div', [_vm._v("This system is for authorized users only.")]), _vm._v(" "), _c('div', [_vm._v("Unauthorized access or sharing of login credentials")]), _vm._v(" "), _c('div', [_vm._v("may result in disciplinary and/or legal action")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a691fb6","hasScoped":true}!./src/views/components/login/login.component.html
// module id = 603
// module chunks = 1